var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcStickerYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_900_2306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5512 142.182C131.16 133.005 151.63 97.5495 142.272 62.9898C132.915 28.4301 97.2731 7.85332 62.6645 17.0302C28.0558 26.2071 7.58581 61.6627 16.9434 96.2223C26.3009 130.782 61.9426 151.359 96.5512 142.182Z",
    fill: "#F2B203",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1991 37.4732C46.7412 43.1625 34.0457 65.1507 39.847 86.5784C45.6484 108.006 67.752 120.768 89.21 115.078C110.668 109.389 123.363 87.4009 117.562 65.9732C111.761 44.5456 89.6571 31.7839 68.1991 37.4732ZM88.0354 110.74C68.9736 115.794 49.345 104.461 44.1915 85.4265C39.038 66.3917 50.3119 46.8655 69.3737 41.8116C88.4355 36.7576 108.059 48.0917 113.212 67.1265C118.366 86.1614 107.092 105.687 88.0354 110.74ZM70.7654 81.1995C71.476 83.8241 69.9191 86.5126 67.2962 87.2081C64.6679 87.9049 61.9667 86.3453 61.2561 83.7208C60.5455 81.0962 62.097 78.4091 64.7253 77.7122C67.3482 77.0168 70.0563 78.5803 70.7654 81.1995ZM97.5717 74.0922C98.2823 76.7167 96.7254 79.4053 94.1025 80.1007C91.4742 80.7976 88.773 79.238 88.0624 76.6134C87.3518 73.9889 88.9033 71.3017 91.5316 70.6049C94.1598 69.908 96.8626 71.473 97.5717 74.0922ZM99.174 63.0682L102.272 57.1408L92.5466 59.7193C86.7799 57.6902 80.3788 57.3137 74.0213 58.9993C67.6692 60.6835 62.3335 64.1776 58.3682 68.7812L48.6215 71.3655L54.2989 74.9662C52.2737 78.1255 51.5456 82.1019 52.6064 86.0199C54.6082 93.414 62.232 97.8156 69.6366 95.8524C73.1553 94.9195 75.9894 92.7182 77.7806 89.8694L83.3401 93.3974L86.3724 87.5914C89.3629 89.1724 92.9295 89.6766 96.4428 88.7451C103.847 86.7819 108.232 79.1964 106.23 71.8024C105.168 67.879 102.524 64.8023 99.174 63.0682ZM68.4581 91.5209C63.4498 92.8488 58.2872 89.8682 56.9332 84.8669C55.5792 79.8657 58.5443 74.7301 63.5526 73.4022C68.5609 72.0744 73.7235 75.055 75.0775 80.0562C76.4315 85.0574 73.4718 90.1916 68.4581 91.5209ZM79.3465 78.6471C77.7328 72.6866 72.0036 68.7241 65.6852 68.0542C68.4328 65.9395 71.6388 64.3212 75.2061 63.3754C78.7734 62.4295 82.3729 62.2434 85.8209 62.7155C80.6872 66.4217 77.7328 72.6866 79.3465 78.6471ZM95.2697 84.4121C90.2614 85.74 85.0989 82.7594 83.7449 77.7582C82.3908 72.7569 85.356 67.6214 90.3643 66.2935C95.3726 64.9656 100.535 67.9462 101.889 72.9474C103.243 77.9487 100.278 83.0842 95.2697 84.4121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3725 115.508C56.3725 115.508 53.0676 111.099 46.3952 107.519C39.7227 103.94 32.7732 104.806 32.7732 104.806C32.7732 104.806 36.5988 109.493 43.6987 113.306C50.8027 117.111 56.3725 115.508 56.3725 115.508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7745 119.303C71.7745 119.303 68.3175 117.366 62.8055 116.748C57.2935 116.13 52.8158 118.328 52.8158 118.328C52.8158 118.328 56.7022 120.313 62.5716 120.969C68.437 121.632 71.7745 119.303 71.7745 119.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5052 118.487C85.5052 118.487 82.3445 118.071 78.1419 119.342C73.9394 120.612 71.4175 123.753 71.4175 123.753C71.4175 123.753 74.9045 124.07 79.3809 122.721C83.8626 121.371 85.5052 118.487 85.5052 118.487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2759 105.131C47.2759 105.131 44.9358 100.12 39.1459 95.2496C33.356 90.379 26.4008 89.8144 26.4008 89.8144C26.4008 89.8144 29.1916 95.2087 35.3564 100.396C41.5213 105.583 47.2759 105.131 47.2759 105.131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7 90.5095C37.7 90.5095 37.2784 84.9145 33.626 78.218C29.9736 71.5215 23.7496 68.4873 23.7496 68.4873C23.7496 68.4873 24.4563 74.6016 28.3422 81.733C32.2334 88.8629 37.7 90.5095 37.7 90.5095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.86 99.2049C117.86 99.2049 118.495 93.7515 122.465 87.3502C126.435 80.9489 132.892 78.2609 132.892 78.2609C132.892 78.2609 131.947 84.2125 127.724 91.0273C123.494 97.8382 117.86 99.2049 117.86 99.2049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.444 110.111C106.444 110.111 108.46 106.723 112.921 103.461C117.383 100.198 122.371 99.8866 122.371 99.8866C122.371 99.8866 120.008 103.528 115.256 107C110.511 110.476 106.444 110.111 106.444 110.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1406 116.197C94.1406 116.197 96.6681 114.274 100.949 113.294C105.231 112.315 109.002 113.788 109.002 113.788C109.002 113.788 106.142 115.788 101.584 116.834C97.0205 117.883 94.1406 116.197 94.1406 116.197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.502 85.7165C120.502 85.7165 119.997 80.2187 122.55 73.136C125.104 66.0532 130.842 62.1231 130.842 62.1231C130.842 62.1231 131.151 68.1756 128.432 75.718C125.714 83.2603 120.502 85.7165 120.502 85.7165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.406 68.3158C121.406 68.3158 118.945 63.2617 118.725 55.6551C118.505 48.0486 122.357 42.3428 122.357 42.3428C122.357 42.3428 124.834 47.9878 125.071 56.0865C125.309 64.1852 121.406 68.3158 121.406 68.3158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9203 121.395C92.1125 121.079 92.8178 119.857 92.4954 118.667C92.1731 117.476 90.9453 116.767 89.753 117.083C88.5608 117.399 87.8556 118.621 88.1779 119.811C88.5002 121.002 89.728 121.711 90.9203 121.395Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_900_2306",
    x: 9.86932,
    y: 10.0427,
    width: 140.35,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.436428,
    dy: 0.436428
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_900_2306"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_900_2306",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcStickerYellow);
export default __webpack_public_path__ + "static/media/tc-sticker-yellow.2452e51edf97c46e28d7bcd69c4b7acb.svg";
export { ForwardRef as ReactComponent };